import React from 'react';
import { CategoriesList } from '../CategoriesList';
import type { CategoriesListProps } from '../CategoriesList';

import * as felaRules from './PostCategoriesList.rules';

export interface PostCategoriesListProps extends Omit<CategoriesListProps, 'extend'> {}

export const PostCategoriesList = (props: PostCategoriesListProps) => {
    return <CategoriesList {...props} extend={felaRules} />;
};
